import { Chemical } from '../types';

/**
 * `latestRevision` is not included in the returned object because it is set by the service layer.
 * Latest Revision is required but unable to be apart of the initial creation of the chemical.
 */
export function createChemical(
	payload: Partial<Chemical>,
): Partial<Omit<Chemical, 'latestRevision'>> {
	return {
		...payload,
		name: payload.name,
		activeIngredient: payload.activeIngredient,
	};
}
